import * as RxOperators from 'rxjs/operators'

import TrackingManager from '~/analytics/tracking_manager/index'
import GtmEmitter from '~/analytics/main/gtm_emitter'
import EventSubjects from '~/shared/event_subjects'

function installer () {
  global.AnalyticsNamespace = global.AnalyticsNamespace || {}
  const AnalyticsNamespace = global.AnalyticsNamespace

  const panoramaGtmEmitter = new GtmEmitter()
  AnalyticsNamespace.panoramaGtmEmitter = panoramaGtmEmitter

  if (window) {
    panoramaGtmEmitter.setupBrowser(window)
  }

  const trackingManager = new TrackingManager()

  trackingManager.onUidChangedAsObservable()
    .subscribe((uid) => {
      panoramaGtmEmitter.emitUid(uid)
    })

  /**
   * トラッキングID取得に必要な初期処理。Google Tag Manage側で実行する。
   *
   * @param {string} options.hubPage ユーザ情報を格納しているページ
   */
  AnalyticsNamespace.setup = ({ hubPage }: { hubPage: string | null }) => {
    if (!hubPage) {
      return
    }
    try {
      trackingManager.connect(hubPage)
        .catch((err) => {
          console.error(err)
        })
    } catch (e) {
      console.error(e)
    }
  }

  AnalyticsNamespace.attachPanoramaEvents = (eventSubjects: EventSubjects) => {
    eventSubjects.onItemShownAsObservable()
      .pipe(
        RxOperators.filter((e) => e.placeId && (e.placeId !== panoramaGtmEmitter.currentPlaceId()))
      )
      .subscribe((e) => {
        panoramaGtmEmitter.onPlaceChanged(e)
      })

    eventSubjects.onPointChangeAsObservable().subscribe((e) => {
      panoramaGtmEmitter.onEnterPage(e)
    })

    eventSubjects.onAirTagClickAsObservable()
      .pipe(
        RxOperators.filter((data) => data.index != null)
      )
      .subscribe((data) => {
        panoramaGtmEmitter.onEvent('air_tag', { index: data.index })
      })

    eventSubjects.onFovChangedByUserAsObservable()
      .pipe(
        RxOperators.debounceTime(500),
        RxOperators.distinctUntilChanged()
      )
      .subscribe((fov) => {
        panoramaGtmEmitter.onEvent('zoom')
      })
  }
}

export { installer }
